











 








const node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "InviteTeamMemberAvatar_teamMembers",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "AddTeamMemberModal_teamMembers"
    }
  ],
  "type": "TeamMember",
  "abstractKey": null
};

(node ).hash = "19f9748d71d3353016099ae7ec3c7347";

export default node;
